import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';

/**
 * `availableFilters` da Central (CreditProductRulesListContainer.tsx:47-58): Todos, Nome e Tipo de
 * regra (1 Compliance, 2 Crédito), cada um no fio com a própria chave e o valor como texto.
 */
export const productRulesFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Buscar regras` },
  { key: 'name', type: 'text', label: msg`Nome` },
  {
    key: 'rulesType',
    type: 'select',
    label: msg`Tipo de regra`,
    options: [
      { value: '1', label: msg`Compliance` },
      { value: '2', label: msg`Crédito` },
    ],
  },
]);
